<div class="bcl-table-header" (click)="onClick()">
  @if (header().headerDisplayType === HEADER_DISPLAY_TYPES.icon && header().icon) {
    <ogs-m3-icon [icon]="header().icon!"/>
  }
  @else {
    <span class="mat-body-medium" [attr.title]="header().translationInfo!.defaultText | translate : header().translationInfo!.token : header().translationInfo!.scope">
      {{ header().translationInfo!.defaultText | translate : header().translationInfo!.token : header().translationInfo!.scope }}
   </span>
  }
</div>

@if (header().options) {
  <app-table-header-icon-resolver (click)="onClick()" class="table-header__icons" [headerConfig]="header().options!" />
}

@if(hasMenu()){
  <button #menuTrigger
          [class]="{'table-column-menu__trigger--active': isMenuOpen(), 'table-column-menu__trigger': true}"
          (menuOpened)="isMenuOpen.set(true)"
          (menuClosed)="isMenuOpen.set(false)">
    <ogs-m3-icon class="icon" prefix="fal" icon="ellipsis-vertical" />
  </button>
  <div appFloating [triggerRef]="menuTrigger" position="bottom" alignment="end" class="bcl-table__column-menu">
    <ng-content select="app-table-column-menu" />
  </div>

}
